module.exports = {
  src: __webpack_public_path__ + "assets/images/apple_icon.75bc5702fca7380e.svg",
  width: 18,
  height: 18,
  toString: function() { return __webpack_public_path__ + "assets/images/apple_icon.75bc5702fca7380e.svg"; }
};